"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushMessageTopic = void 0;

/**
 * Instead of distinguishing between created, deleted and updated events, usually just catch those in one `xy:changed` event
 */
var PushMessageTopic;
exports.PushMessageTopic = PushMessageTopic;

(function (PushMessageTopic) {
  PushMessageTopic["FormTemplateGenerated"] = "formTemplate:generated";
  PushMessageTopic["LogCalendarEventChanged"] = "logCalendarEvent:changed";
  PushMessageTopic["TaskCalendarEventChanged"] = "taskCalendarEvent:changed";
  PushMessageTopic["Test"] = "test";
})(PushMessageTopic || (exports.PushMessageTopic = PushMessageTopic = {}));

var PMT = PushMessageTopic;
/**
 * Likely on the frontend, messages will be throttled based on their message types _and_ arguments, so
 * be careful not to include extraneous arguments in the handlers that aren't truly needed to uniquely
 * handle each message.
 */